import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchAssetTimeline = createAsyncThunk("fetchAssetTimeline", async ({ id }) => {
	const response = await axiosHttp.get(`assets/${id}/timeline`);
	return response.data?.data ?? response.data;
});

const AssetTimelineSlice = createSlice({
	name: "assetTimelineSlice",
	initialState: {
		isLoading: false,
		data: [],
		error: null,
	},
	reducers: {
		resetStateAssetTimeline: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = [];
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchAssetTimeline.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchAssetTimeline.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchAssetTimeline.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetStateAssetTimeline } = AssetTimelineSlice.actions;
export default AssetTimelineSlice.reducer;
